function broadcast(componentName, eventName, params) {
    this.$children.forEach(child => {
      var name = child.$options.componentName;
  
      if (name === componentName) {
        child.$emit.apply(child, [eventName].concat(params));
      } else {
        broadcast.apply(child, [componentName, eventName].concat([params]));
      }
    });
}
export default {
    methods: {
        dispatch(componentName, eventName, params) {
            var parent = this.$parent || this.$root;
            var name = parent.$options.componentName;

            // console.log(this.$parent, this.$root,this.$parent || this.$root,name)
            while (parent && (!name || name !== componentName)) {
                parent = parent.$parent;
                // console.log(111,parent,parent&&parent.$options.componentName)

                if (parent) {
                    name = parent.$options.componentName;
                }
            }
            if (parent) {
                // console.log(222,parent,[eventName].concat(params))
                parent.$emit.apply(parent, [eventName].concat(params));
            }
        },
        broadcast(componentName, eventName, params) {
            // console.log(333,'broadcast')
            broadcast.call(this, componentName, eventName, params);
        }
    }
};
  